/**
 * Converts TripFormState into a TripRequest with LocalDateTime wire strings
 * suitable for the API. Pure function — no side effects.
 */
import type { TripFormState, TripRequest } from '../../types';
import {
  fromMantineDateTimeString,
  toApiLocalDateTime,
} from '../mantineDateUtils';

function toLockDateWire(value: string): string | null {
  const parsed = fromMantineDateTimeString(value);
  if (!parsed) {
    return null;
  }
  return toApiLocalDateTime(parsed);
}

export function buildRequest(formData: TripFormState): TripRequest {
  const lockStartDate = formData.lockEnabled
    ? toLockDateWire(formData.lockStartDate)
    : null;
  const lockEndDate = formData.lockEnabled
    ? toLockDateWire(formData.lockEndDate)
    : null;

  const trimmedDescription = formData.description.trim();

  return {
    name: formData.name.trim(),
    description: trimmedDescription || undefined,
    visibility: formData.visibility,
    status: formData.status,
    occasions: formData.occasions,
    lockStartDate,
    lockEndDate,
    budgetAmount: formData.budgetEnabled
      ? parseFloat(formData.budgetAmount) || null
      : null,
    budgetCurrency: formData.budgetEnabled
      ? formData.budgetCurrency || null
      : null,
  };
}
